import React ,{Component} from "react"
import axios  from "axios";
import { Autocomplete, responsiveFontSizes, TableCell, TableRow, TextField } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import { Button } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import {NavLink, Navigate  } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table'; 
import TableContainer from '@mui/material/TableContainer';  

import TableHead from '@mui/material/TableHead';  
import { styled } from '@mui/system';
import TableSortLabel from '@mui/material/TableSortLabel'; 
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';  
import TableBody from '@mui/material/TableBody';
//import { styled } from '@mui/material/styles';  
import EditIcon from '@mui/icons-material/Edit';
import Checkbox from '@mui/material/Checkbox'; 
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Select from '@mui/material/Select';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import pdfimage from './images/pdfimage.jpg';
import csvimage from './images/csvimage.png';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import psdfimage from './images/psdfimage.png';

const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));


const useStyles = styled(theme =>({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
 
form: {
    width: '500%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
     minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  
})
)


export default class AuditTRail  extends React.Component{

    constructor(props) {
    super();



      var strdob = new Date();
      var month = "";

      if ((strdob.getMonth() + 1) < 10) {
          month = "0" + (strdob.getMonth() + 1);
      } else {
          month = (strdob.getMonth() + 1);
      }

const currentDate = new Date();

var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();


    const currentMonth = new Date().getMonth() + 1;
    this.state={
        
	  isselectdisplay:false,
      todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: lastDayOfMonth,
      fromdate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
      fromdate1:currentDate.getFullYear() + '-' + month1 + '-' + '01',pdflogo:'',
      submitbtn:'Save',AuditData:[],pagename:'',redirect:false,page:0,rowsPaging:[],rowsPerPage:30,CategoryData:[],le_category:'',le_ledgername:'',
      selectedCategoryName:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],exportdata:[],month: currentMonth, name:'',

    type:0,

    };
	 this.updateDonenewParent = this.updateDonenewParent;

    }

updateDonenewParent = (childData) =>{
	
		  
}


componentWillMount() {
    
  
  if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {	
  this.apicall(this.state.page,this.state.rowsPerPage);	  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
           
     this.props.parentdasCallback(
            "Audit Trail"
        ); 

   
 
 

  }



PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=35')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
  this.apicall(this.state.page,this.state.rowsPerPage);
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}






myChangeHandler = (event) => {
    let nam = event.target.name;
    let val =  event.target.value;

   
    this.setState({[nam]: val},()=>{});
   

}



myChangeHandlerCat = (event) => {

  
    const name = event.target.name;
    const value = event.target.value;


    const selectedIndex = event.target.selectedIndex;
    const selectedText = event.target.options[selectedIndex].text;

    this.setState({
        [name]: value,
        selectedCategoryName: selectedText
    }, () => {
      
    });
};


apicall(page,rowsPerPage){
 
axios.get(localStorage.getItem("ISIurl")+'ajaxreports.php?action=audittrailreport&StartIndex='+page+'&PageSize='+rowsPerPage+'&month='+this.state.month+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&cmp_id='+localStorage.getItem('ISIcmpid')+'&type='+this.state.type+'&name='+this.state.name)
  .then(resp => {  

        if(resp.data.length>0){
        
            this.setState({  
              AuditData: resp.data, 
            
                  totaldata  :resp.data[0]["count"]      
               
            });
   this.exportapicall();

    }
     else{
           this.setState({AuditData:[],totaldata:0,exportdata:resp.data});
     }
   
    });

}

exportapicall(page,rowsPerPage){
 
axios.get(localStorage.getItem("ISIurl")+'ajaxreports.php?action=audittrailreport&month='+this.state.month+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&cmp_id='+localStorage.getItem('ISIcmpid')+'&type='+this.state.type+'&name='+this.state.name)
  .then(resp => {  

        if(resp.data.length>0){
        
            this.setState({  
            
              exportdata:resp.data,
                          
               
            });
   

    }
     else{
           this.setState({AuditData:[],totaldata:0,exportdata:resp.data});
     }
   
    });

}
  
 
handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
      prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
    
    
  };
  

handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 
} 





   Handlepdfopen = () => {
	
	 
	  this.setState({pdfopen: !this.state.pdfopen, fromdate:this.state.fromadate1,todate:this.state.todate1},()=>{
		
		});
 
  };
  



  
  fromdatehandler = (date) => {
      var month = "";
      var dateObj = new Date(date);
  
         if ((dateObj.getMonth() + 1) < 10) {
          month = "0" + (dateObj.getMonth() + 1);
      } else {
          month = (dateObj.getMonth() + 1);
      }
  
      
      this.setState({
          fromdate: dayjs(dateObj),
          fromdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
      });
  }
  
    
    
    toatehandler = (date) => {
      var month = "";
      var dateObj = new Date(date);
  
         if ((dateObj.getMonth() + 1) < 10) {
          month = "0" + (dateObj.getMonth() + 1);
      } else {
          month = (dateObj.getMonth() + 1);
  
      }

       this.setState({
          todate: dayjs(dateObj),
          todate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
      });
  
    }
      
  



  Handleclickviewmore= (e) =>{
	  
	  this.setState({isselectdisplay:true});
	  
  }


 CloseMoreoption = (date) =>{
	
	this.setState({isselectdisplay:false});
}

    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };
	
	
		
handleClickOpen = () => {
  
      this.GetLogoForpdf();
  
  };

GetLogoForpdf() {
  axios
    .get(`${localStorage.getItem("ISIurl")}ajaxbusinesssetting.php`, {
      params: {
        action: "getpdflogo",
        bs_cmp_id: localStorage.getItem("ISIcmpid"),
        bs_id: 2,bs_page:5
      },
    })
    .then((resp) => {
      if (resp.data.status === "success") {
        this.setState(
          {
            pdflogo: resp.data.base64,
          },
          () => {
            setTimeout(() => {
              this.handleDownload();
            }, 500);
          }
        );
      } else {
        console.error("Error:", resp.data.message);
      }
    })
    .catch((error) => {
      console.error("Request failed:", error);
    });
}
	
handleDownload = () => {
    const { AuditData, fromdate, todate } = this.state;
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();

    
    const imgWidth = 45;
    const imgHeight = 20;
    const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    if (this.state.pdflogo) {
	 const logoImage = this.state.pdflogo.startsWith('data:image')
      ? this.state.pdflogo
      : `data:image/jpeg;base64,${this.state.pdflogo}`;
  doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);
 }

  
    doc.setFontSize(16);
    const title = 'Audit Trail Report';
    doc.text(title, pageWidth / 2, 38, { align: 'center' });

    
    doc.setFontSize(11);
    const dateText = `From: ${dayjs(fromdate).format('DD/MM/YYYY')}  To: ${dayjs(todate).format('DD/MM/YYYY')}`;
    doc.text(dateText, pageWidth / 2, 44, { align: 'center' });

 
    const tableColumns = ["Entry Date", "User", "Name", "Type", "Invoice Number", "Ref", "Net", "Total"];

   
    const tableRows = AuditData.map(item => {
        const isBlankNet = [6, 7, 8, 9].includes(Number(item.value)); 
        return [
            item.entrydate,
            `${item.us_firstname} ${item.us_lastname}`,
            item.cu_contactname,
            item.type,
            item.invoiceno,
            item.reference,
            isBlankNet ? "" : Number(item.summed_total || 0).toFixed(2),
            Number(item.summed_total || 0).toFixed(2)
        ];
    });

  
    doc.autoTable({
        head: [tableColumns],
        body: tableRows,
        startY: 50,
        theme: 'striped',
        styles: { fontSize: 10 },
        headStyles: { fillColor: [224, 224, 224], textColor: 0, fontStyle: 'bold' },
        columnStyles: { 6: { halign: 'right' }, 7: { halign: 'right' } }
    });


    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(10);
        doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, doc.internal.pageSize.getHeight() - 10);
    }


    doc.save('Audit_Trail_Report.pdf');
};

	
	
render() {


  if(this.state.redirect===true){
     return <Navigate to={this.state.pagename} />
  }


  const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    
return (

  <React.Fragment>
    

     <div className="searchboxcat">


    <ul>
    
    
     <li>
            <p>Search</p>
            <p>
              <TextField
                variant="outlined"
                fullWidth
                className="txtbox"
                value={this.state.name}
                id="name"
                inputProps={{ tabIndex: "1", maxLength: 150 }}
                name="name"
                onChange={this.myChangeHandler}
                InputProps={{
                  endAdornment: (
                    <SearchOutlinedIcon style={{ marginLeft: 8 }} />
                  ),
                }}
              />
            </p>
          </li>




<li style={{'width':'20%'}}>
 <p>Period </p>  
 <FormControl  className="businessdrp">
                   
      <Select
    native
    native
    fullWidth
    variant="outlined"
    margin="normal"
    value={this.state.month} 
    onChange={this.myChangeHandlerCat}
    id="month"
    name="month"
    className="txtboxs"
    inputProps={{ tabIndex: "1" }}
  >
    {months.map((month, index) => (
      <option key={index} value={index + 1}>
        {month}
      </option>
    ))}
  </Select>

</FormControl>

</li>
    
<li>

 <p>From Date</p>
<p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }

    onChange={this.fromdatehandler} format="MM/DD/YYYY"
  className="txtbox"
/>  </DemoContainer>
</LocalizationProvider></p>

</li>


<li>
 <p>To Date</p>

<p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="datepicker"
onChange={this.toatehandler} format="MM/DD/YYYY"
className="txtbox"
/>  </DemoContainer>
    </LocalizationProvider> </p></li>




<li>
  <p>
  <Button
  type="submit"
  variant="outlined" 
  className="morebtn"
  onClick={this.Handleclickviewmore}
            
            >
              More
            </Button>
        
    <span className="closeincon">
     {this.state.isselectdisplay === true && (
        <CloseRoundedIcon onClick={this.CloseMoreoption} />
      )}
     </span>
        
        
  </p></li>


  <li>
    {this.state.isselectdisplay===true &&(
	   <React.Fragment>
    <li>
  <p>Status</p> <p><Select
    native
    variant="outlined" className="txtbox"
    margin="normal"
    fullWidth 
    onChange={this.myChangeHandler}
    id="role"
    value={this.state.sestatus}
    name="sestatus"
    inputProps={{tabIndex: "4"}}
          ><option value={0}>All</option>
    <option value={1}>Draft</option>
    <option value={2}>Pending</option>
    <option value={3}>Invoiced</option>	
    <option value={4}>Expired</option>	
    <option value={5}>Declained</option>	
    </Select></p>
  
  
  </li>
  
   


  
  
   </React.Fragment> )}
</li>

   {this.state.isselectdisplay===true &&(
 <li>
  <p>Type</p> <p><Select
    native
    variant="outlined" className="txtbox"
    margin="normal"
    fullWidth 
    onChange={this.myChangeHandler}
    id="role"
    value={this.state.type}
    name="type"
    inputProps={{tabIndex: "4"}}
          ><option value={0}>All</option>
    <option value={1}>Vendor Bill</option>
    <option value={2}>Sales Credit Note</option>
    <option value={3}>Sales Invoice</option>	
    
	<option value={6}>Customer Receipt</option>	
	<option value={7}>Customer Refund</option>	
	<option value={8}>Vendor Refund</option>	
	<option value={9}>Vendor Payment</option>	
	
    </Select></p>
  
  
  </li>
   )}







    <li>
                            <p>&nbsp;</p>
                            <p className="searchbutton">
                                <Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
                                    Calculate
                                </Button>
                                &nbsp;
								
								<Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog} 
                                >
                                    EXPORT
                                </Button>
								
                               
                            </p>
                        </li>





     </ul>
    </div>
     <div className="clear"></div>
  

<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>
    <Table stickyHeader aria-label="sticky table">
      <TableHead>
        <TableRow>
          <TableCell>Entry Date</TableCell>
          <TableCell>User</TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Type</TableCell>
          <TableCell>Invoice Number</TableCell>
          <TableCell>Ref</TableCell>
          <TableCell>Net</TableCell>
          <TableCell>Total</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {this.state.AuditData.length === 0 ? (
          <TableRow>
            <TableCell colSpan={8}>
              <h3>No Records</h3>
            </TableCell>
          </TableRow>
        ) : (
          this.state.AuditData.map((item, index) => {
            const isBlankNet = [6, 7, 8, 9].includes(Number(item.value));
            return (
              <TableRow key={index}>
                <TableCell>{item.entrydate}</TableCell>
                <TableCell>{item.us_firstname} {item.us_lastname}</TableCell>
                <TableCell>{item.cu_contactname}</TableCell>
                <TableCell>{item.type}</TableCell>
                <TableCell>{item.invoiceno}</TableCell>
                <TableCell>{item.reference}</TableCell>
                <TableCell>{isBlankNet ? "" : Number(item.summed_total || 0).toFixed(2)}</TableCell>
                <TableCell>{Number(item.summed_total || 0).toFixed(2)}</TableCell>
              </TableRow>
            );
          })
        )}
      </TableBody>
    </Table>
  </TableContainer>

</Paper>

<Table id="balance-report-table" style={{ display: 'none' }}>
  <TableHead>
    <TableRow>
      <TableCell>Entry Date</TableCell>
      <TableCell>User</TableCell>
      <TableCell>Name</TableCell>
      <TableCell>Type</TableCell>
      <TableCell>Invoice Number</TableCell>
      <TableCell>Ref</TableCell>
      <TableCell>Net</TableCell>
      <TableCell>Total</TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    {this.state.AuditData.map((item, index) => {
      const isBlankNet = [6, 7, 8, 9].includes(Number(item.value));
      return (
        <TableRow key={index}>
          <TableCell>{item.entrydate}</TableCell>
          <TableCell>{item.us_firstname} {item.us_lastname}</TableCell>
          <TableCell>{item.cu_contactname}</TableCell>
          <TableCell>{item.type}</TableCell>
          <TableCell>{item.invoiceno}</TableCell>
          <TableCell>{item.reference}</TableCell>
          <TableCell>{isBlankNet ? "" : Number(item.summed_total || 0).toFixed(2)}</TableCell>
          <TableCell>{Number(item.summed_total || 0).toFixed(2)}</TableCell>
        </TableRow>
      );
    })}
  </TableBody>
</Table>
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150,200]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      /> 
 <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Generated Detailed  Balance report</DialogTitle>
					
                    <DialogContent>
					<p> To generate a new report, based on the latest selection criteria you've specified, choose the format 
					you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
                        
				<p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
				 <ReactHTMLTableToExcel
                                    variant="contained"
                                    color="primary"
                                    id="test-table-xls-button"
                                    className="my-custom-excel-button"
                                    table="balance-report-table"
                                    filename="Balance Report"
                                    sheet="Balance Report"
                                    buttonText=""
                                />
                         <img
    src={psdfimage}
    width={100}
    height={100}
    style={{ cursor: "pointer" }}
    onClick={this.handleClickOpen}
    alt="Download PDF"
  />
						
						</p>
						
						
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>


  </React.Fragment>
 
);

}



}


